import React from "react";
import {
  Route,
  Routes,
  BrowserRouter,
  Navigate,
  useLocation,
} from "react-router-dom";

import Index from "./Pages/Index";
import Menu from "./Pages/Menu";
import Servicos from "./Pages/Servicos";
import Pastas from "./Pages/Pastas";
import CadCargo from "./Pages/CadCargo";
import CadOperador from "./Pages/CadOperador";
import CadCliente from "./Pages/CadCliente";
import VincularUsuarioProcesso from "./Pages/CadUsuarioProcesso";
import Planejamento from "./Pages/Planejamento";
import CadastroPlanejamento from "./Pages/CadPlanejamento";
import Patrimonio from "./Pages/Patrimonio";
import CadPatrimonio from "./Pages/CadPatrimonio";
import CadastroOperadorExterno from "./Pages/CadOperadorExterno";
import AprovarOperadoresExternos from "./Pages/AprovOperadorExterno";
import CadUploadEstrutura from './Pages/CadUploadEstrutura';
import VincularProcessoUsuarios from './Pages/CadProcessoUsuario';
import Auditoria from "./Pages/Auditoria/ListaClientesAuditoria";
import AuditoriaSecaoCliente from "./Pages/Auditoria/Secao";
import AuditoriaQuestao from "./Pages/Auditoria/Questao";
import AcompanhamentoQuestao from "./Pages/Auditoria/Questao/acompanhamentoQuestao";
import AuditoriaChecklist from "./Pages/Auditoria/Checklist";
import CadOperadorSecao from "./Pages/CadOperadorSecao";
import RecuperarSenhaSolicitar from "./Pages/RecuperarSenhaSolicitar";
import RecuperarSenhaConfirmar from "./Pages/RecuperarSenhaConfirmar";
import Agenda from "./Pages/Agenda";
import CadAgendaGrupo from "./Pages/CadAgendaGrupo";
import SisAuditoriaConsulta from "./Pages/SisAuditoriaConsulta";


import { useAuthContext } from "./context/authContext";
import { operadorEhGerente } from "./Utils/cargos";

const routeNames = {
  index: "/",
  menu: "/Menu",
  upload: "/Upload",
  Servicos: "/Servicos/:IDCliente",
  Pastas: "/Pastas/:IDCliente/:IDProcesso/:IDPastaPai",
  CadCargo: "/CadCargo",
  CadOperador: "/CadOperador",
  CadCliente: "/CadCliente",
  UsuarioProcesso: "/CadOperadorProcesso",
  Planejamento: "/Planejamento/:IDCliente/:IDProcesso",
  CadPlanejamento: "/CadastroPlanejamento",
  Patrimonio: "/AuditoriaPatrimonial/:IDCliente",
  CadPatrimonio: "/CadPatrimonio/:IDCliente",
  CadExterno: "/cadexterno/:idCliente",
  AprovarOperadoresExternos: "/aprovexterno",
  CadUploadEstrutura: "/UploadEstrutura/:IDProcesso/:IDDiretorioPai/:NomeBucketAws",
  VincularProcessoUsuarios: "/CadProcessoOperador",
  Auditoria: "/Auditoria",
  AuditoriaSecaoCliente: "/AuditoriaSecao/:IDClienteAuditoria",
  AuditoriaQuestao: "/AuditoriaQuestao",
  AcompanhamentoQuestao: "/Auditoria/:IDSecao/Acompanhamento",
  AuditoriaChecklist: "/AuditoriaChecklist/:IDSecao",
  CadOperadorSecao: "/AuditoriaOperadorSecao",
  RecuperarSenha: "/recuperar-senha",
  RecuperarSenhaConfirmar: "/recuperar-senha/confirmar",
  Agenda: "/Agenda",
  CadAgendaGrupo: "/CadAgendaGrupo",
  SisAuditoriaConsulta: "/ConsultaAuditoria"
};

const ProtectedRoute = ({ children, bloquearGerente = false }) => {
  const { isAuthenticated, authReady, operador } = useAuthContext();
  const location = useLocation();

  if (!authReady) return <div>Carregando...</div>;

  if (!isAuthenticated && location.pathname !== "/") {
    return <Navigate to="/" replace />;
  }

  if (bloquearGerente && operadorEhGerente(operador)) {
    return <Navigate to={routeNames.menu} replace />;
  }

  return children;
};

const Rotas = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Rota pública: Login */}
        <Route path={routeNames.index} element={<Index />} />
        <Route path={routeNames.CadExterno} element={<CadastroOperadorExterno />} />
        <Route path={routeNames.RecuperarSenha} element={<RecuperarSenhaSolicitar />} />
        <Route path={routeNames.RecuperarSenhaConfirmar} element={<RecuperarSenhaConfirmar />} />


        {/* Rotas protegidas */}
        <Route path={routeNames.menu} element={<ProtectedRoute> <Menu /> </ProtectedRoute>} />
        <Route path={routeNames.Servicos} element={<ProtectedRoute> <Servicos /></ProtectedRoute>} />
        <Route path={routeNames.Pastas} element={<ProtectedRoute> <Pastas /> </ProtectedRoute>} />
        <Route path={routeNames.CadCargo} element={<ProtectedRoute bloquearGerente> <CadCargo /> </ProtectedRoute>} />
        <Route path={routeNames.CadOperador} element={<ProtectedRoute bloquearGerente> <CadOperador /> </ProtectedRoute>} />
        <Route path={routeNames.CadCliente} element={<ProtectedRoute bloquearGerente> <CadCliente /> </ProtectedRoute>} />
        <Route path={routeNames.CadPlanejamento} element={<ProtectedRoute bloquearGerente> <CadastroPlanejamento /> </ProtectedRoute>} />
        <Route path={routeNames.UsuarioProcesso} element={<ProtectedRoute bloquearGerente> <VincularUsuarioProcesso /> </ProtectedRoute>} />
        <Route path={routeNames.Planejamento} element={<ProtectedRoute> <Planejamento /> </ProtectedRoute>} />
        <Route path={routeNames.Patrimonio} element={<ProtectedRoute> <Patrimonio /> </ProtectedRoute>} />
        <Route path={routeNames.CadPatrimonio} element={<ProtectedRoute> <CadPatrimonio /> </ProtectedRoute>} />
        <Route path={routeNames.AprovarOperadoresExternos} element={<ProtectedRoute bloquearGerente> <AprovarOperadoresExternos /> </ProtectedRoute>} />
        <Route path={routeNames.CadUploadEstrutura} element={<ProtectedRoute> <CadUploadEstrutura /> </ProtectedRoute>} />
        <Route path={routeNames.VincularProcessoUsuarios} element={<ProtectedRoute bloquearGerente> <VincularProcessoUsuarios /> </ProtectedRoute>} />
        <Route path={routeNames.Auditoria} element={<ProtectedRoute> <Auditoria /> </ProtectedRoute>} />
        <Route path={routeNames.AuditoriaSecaoCliente} element={<ProtectedRoute> <AuditoriaSecaoCliente /> </ProtectedRoute>} />
        <Route path={routeNames.AuditoriaQuestao} element={<ProtectedRoute><AuditoriaQuestao /></ProtectedRoute>} />
        <Route path="/AuditoriaQuestao/:modelo" element={<ProtectedRoute><AuditoriaQuestao /></ProtectedRoute>} />
        <Route path="/AuditoriaQuestao/:IDSecao/:modelo" element={<ProtectedRoute><AuditoriaQuestao /></ProtectedRoute>} />
        <Route path={routeNames.AcompanhamentoQuestao} element={<ProtectedRoute><AcompanhamentoQuestao /></ProtectedRoute>} />
        <Route path={routeNames.AuditoriaChecklist} element={<ProtectedRoute><AuditoriaChecklist /></ProtectedRoute>} />
        <Route path={routeNames.CadOperadorSecao} element={<ProtectedRoute><CadOperadorSecao /></ProtectedRoute>} />
        <Route path={routeNames.Agenda} element={<ProtectedRoute><Agenda /></ProtectedRoute>} />
        <Route path={routeNames.CadAgendaGrupo} element={<ProtectedRoute bloquearGerente><CadAgendaGrupo /></ProtectedRoute>} />
        <Route path={routeNames.SisAuditoriaConsulta} element={<ProtectedRoute><SisAuditoriaConsulta /></ProtectedRoute>} />

      </Routes>
    </BrowserRouter>
  );
};

export default Rotas;
